import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { FC } from 'react';

const AboutUs: FC = () => (
  <Box className="about_scalewith">
    <img
      alt="about us grid"
      crossOrigin=""
      src="https://cmtyai-media-assets.nyc3.cdn.digitaloceanspaces.com/app/about-grid-collage-1200.png"
      className="AboutUsImageContainer pdf-image"
      style={{ alignSelf: 'flex-start', objectFit: 'contain', width: '900px' }}
    />
    <Box className="about_scalewith__text__container">
      <Typography className="AboutUs__title">About Us</Typography>
      <Typography>
        The CommunityAI is a SaaS technology company that empowers customers to increase revenue and drive
        growth by embedding social impact into B2B and B2G transactions.
      </Typography>
      <Typography>
        {' '}
        The CommunityAI’s suite of solutions enable businesses, organizations, and public sector entities
        to embed funding for social impact enterprises and programs (e.g., ESG, DE&I, First
        Responders & Veterans, and STEAM Workforce Development) into existing sales and procurement
        transactions at no additional cost.
      </Typography>{' '}
      <Typography>
        The CommunityAI users can redirect underperforming and unused customer acquisition budgets towards
        funding social impact contributions, meeting their social impact goals and commitments while
        delivering unique value to their business partners by providing access to our network of 
        global social impact partners.
      </Typography>
      <Typography>
        {' '}
        The CommunityAI and its predecessor companies have directed more than $100M in funding and
        resources to social impact initiatives and improved the lives of more than 60M people.{' '}
      </Typography>
      <Typography>
        Visit{' '}
        <a
          href="https://communityimpact.ai/"
          target="blank"
          rel="noopener noreferrer"
          title="communityimpact.ai"
          aria-label="communityimpact.ai"
        >
          communityimpact.ai
        </a>{' '}
        to learn more.
      </Typography>
    </Box>
  </Box>
);

export default AboutUs;
